module.exports = __webpack_public_path__ + "static/media/Lato-Light.fcc51c06.woff2";